import { useEffect } from 'react';

import { useProgress } from '@/context/progress';
import ForbiddenJurisdiction from '@/features/forbidden-jurisdiction/components/forbidden-jurisdiction';
import { usePersonalInformationProgressStep } from '@/features/onboarding/personal-information/hooks/use-progress-step';
import PersonalInformationLayout from '@/features/onboarding/personal-information/layout';

const PersonalInformationForbiddenJurisdictionPage = () => {
  const { setCurrentStep } = useProgress();
  const progressStep = usePersonalInformationProgressStep();

  useEffect(() => {
    return setCurrentStep(progressStep, 1);
  }, [progressStep, setCurrentStep]);

  return (
    <PersonalInformationLayout className="-md:justify-center space-y-8" size="sm">
      <ForbiddenJurisdiction />
    </PersonalInformationLayout>
  );
};
PersonalInformationForbiddenJurisdictionPage.displayName = 'PersonalInformationForbiddenPage';

export default PersonalInformationForbiddenJurisdictionPage;
